import EventHandler from 'events/event_handler';
import ImportedAuthorizationEvents from './authorization_events';

export const AuthorizationEvents = ImportedAuthorizationEvents;
export const AuthorizationEventHandler = new EventHandler(Object.values(AuthorizationEvents));

export default AuthorizationEventHandler;
